var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Type } from "@sinclair/typebox";
import { Parse } from "@sinclair/typebox/value";
export var HttpErrorType = Type.Union([
    Type.Literal("unknown"),
    Type.Literal("bad_request"),
    Type.Literal("unauthorized"),
    Type.Literal("forbidden"),
    Type.Literal("not_found"),
    Type.Literal("internal_server_error"),
]);
export var HttpErrorSchema = Type.Object({
    error: HttpErrorType,
    message: Type.String(),
    success: Type.Literal(false),
});
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    function HttpError(message, error) {
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.error = error;
        _this.success = false;
        return _this;
    }
    HttpError.from = function (json, message) {
        try {
            var _a = Parse(HttpErrorSchema, json), error = _a.error, message_1 = _a.message;
            return new HttpError(message_1, error);
        }
        catch (_b) {
            return new HttpError(message !== null && message !== void 0 ? message : "An unknown error occurred", "unknown");
        }
    };
    return HttpError;
}(Error));
export { HttpError };
var ParseError = /** @class */ (function (_super) {
    __extends(ParseError, _super);
    function ParseError(message) {
        var _this = _super.call(this, message) || this;
        _this.message = message;
        return _this;
    }
    return ParseError;
}(Error));
export { ParseError };
//# sourceMappingURL=errors.js.map